export default __webpack_public_path__ + "static/media/m-jobshub-03-v1.9ff1bcf8.jpg";